(() => {
  document.querySelectorAll('[data-eysh2-root]').forEach((root) => {
    if (root.dataset.eysh2Ready === 'true') return;
    root.dataset.eysh2Ready = 'true';

    const navItems=[...root.querySelectorAll('[data-eysh2-nav-item]')];
    const openMode=root.dataset.openMode||'hover_click';
    const openDelay=Number(root.dataset.openDelay||70);
    const closeDelay=Number(root.dataset.closeDelay||180);
    let openTimer,closeTimer;

    const closeAll=(except)=>{
      clearTimeout(openTimer);clearTimeout(closeTimer);
      navItems.forEach((item)=>{
        if(item!==except){item.classList.remove('is-open');item.querySelector('[data-eysh2-trigger]')?.setAttribute('aria-expanded','false')}
      });
    };
    const positionFixedPanels=()=>{
      const bar=root.querySelector('.eysh2__bar');
      if(bar) root.style.setProperty('--eysh2-mega-top',Math.round(bar.getBoundingClientRect().bottom)+'px');
    };
    const openItem=(item)=>{
      clearTimeout(closeTimer);positionFixedPanels();closeAll(item);
      item.classList.add('is-open');item.querySelector('[data-eysh2-trigger]')?.setAttribute('aria-expanded','true');
    };
    const scheduleOpen=(item)=>{clearTimeout(openTimer);openTimer=setTimeout(()=>openItem(item),openDelay)};
    const scheduleClose=(item)=>{clearTimeout(closeTimer);closeTimer=setTimeout(()=>{item.classList.remove('is-open');item.querySelector('[data-eysh2-trigger]')?.setAttribute('aria-expanded','false')},closeDelay)};

    navItems.forEach((item)=>{
      const trigger=item.querySelector('[data-eysh2-trigger]');
      if(!trigger)return;
      if(openMode!=='click'){
        item.addEventListener('mouseenter',()=>scheduleOpen(item));
        item.addEventListener('mouseleave',()=>scheduleClose(item));
        item.addEventListener('focusin',()=>openItem(item));
      }
      trigger.addEventListener('click',(e)=>{
        e.preventDefault();
        const willOpen=!item.classList.contains('is-open');
        closeAll();
        if(willOpen)openItem(item);
      });
    });

    root.querySelectorAll('[data-eysh2-cascade-row]').forEach((row)=>{
      const activate=()=>{
        const parent=row.closest('.eysh2__cascade-main');
        parent?.querySelectorAll('[data-eysh2-cascade-row]').forEach(r=>r.classList.remove('is-active'));
        row.classList.add('is-active');
      };
      row.addEventListener('mouseenter',activate);
      row.addEventListener('focusin',activate);
    });

    document.addEventListener('click',(e)=>{if(!root.contains(e.target))closeAll()});
    document.addEventListener('keydown',(e)=>{if(e.key==='Escape'){closeAll();root.querySelector('[data-eysh2-mobile-drawer]')?.classList.remove('is-open');document.documentElement.style.overflow=''}});

    const drawer=root.querySelector('[data-eysh2-mobile-drawer]');
    root.querySelector('[data-eysh2-mobile-open]')?.addEventListener('click',()=>{drawer?.classList.add('is-open');document.documentElement.style.overflow='hidden'});
    root.querySelectorAll('[data-eysh2-mobile-close]').forEach(el=>el.addEventListener('click',()=>{drawer?.classList.remove('is-open');document.documentElement.style.overflow=''}));

    root.querySelectorAll('[data-eysh2-contact-form]').forEach((form)=>{
      const born=Date.now();
      form.addEventListener('submit',(e)=>{
        const hp=form.querySelector('[data-eysh2-honeypot]');
        const minMs=Number(form.dataset.minSubmitMs||0);
        if((hp&&hp.value.trim()!=='')||(minMs>0&&Date.now()-born<minMs)){
          e.preventDefault();
          const status=form.querySelector('[data-eysh2-form-status]');
          if(status)status.textContent='Please wait a moment and try again.';
        }
      });
    });
  });
})();